import { Component, Input } from '@angular/core';

@Component({
  selector: 'map-feature-item',
  templateUrl: `./map-feature-item.component.html`,
  styleUrls: ['./map-feature-item.component.scss'],
})
export class MapFeatureItemComponent {
  @Input() feature: any;

  public isArray = Array.isArray;
}
